import { styled } from '@mui/material';

export const Asterisks = styled('span', {
  shouldForwardProp: (prop) => prop !== 'areVisible',
})(({ theme, areVisible }) => ({
  display: areVisible ? 'block' : 'none',
  color: theme.palette.colors.down,
  marginLeft: '6px',
}));
